import { atom } from "recoil";

const conceptsAtom = atom({
  key: 'concepts',
  default: {
    payload: [],
    loading: false,
    total: 0,
  }
});

export { conceptsAtom };